


























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "RelatedSelect",
  props: {
    value: { type: Boolean, default: null }
  },
  setup() {
    return {};
  }
});
